import { fallbackInterestRates } from 'axl-config';
async function applyTenantCalculatorConfigs() {
  let externalConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let listing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    supportedDealTypes: _supportedDealTypes,
    ecommerce = '',
    dealerId: _dealerId,
    digitalRetailingType: _digitalRetailingType,
    disableTrade: _disableTrade,
    disclaimerKey: _disclaimerKey,
    enableCreditApp: _enableCreditApp,
    enableCreditVerification: _enableCreditVerification,
    enableDealReceipt: _enableDealReceipt,
    enableNegotiation: _enableNegotiation,
    enableOfferUpgrades: _enableOfferUpgrades,
    enablePayoffQuote: _enablePayoffQuote,
    enablePriceBreakdown: _enablePriceBreakdown,
    enablePriceDetailsInOfferBreakdown: _enablePriceDetailsInOfferBreakdown,
    enableTaxesAndFees: _enableTaxesAndFees,
    esntialDeepLink: _esntialDeepLink,
    hideSendOfferCTA: _hideSendOfferCTA,
    includeNewVehicleIncentives: _includeNewVehicleIncentives,
    includeTaxesAndFees: _includeTaxesAndFees,
    isSingleColumn: _isSingleColumn,
    partnerId: _partnerId,
    showLenderDisclaimer: _showLenderDisclaimer,
    showLenderName: _showLenderName,
    showLendingOptions: _showLendingOptions,
    showNationalAvg: _showNationalAvg,
    showMsrp: _showMsrp,
    showRatesTable: _showRatesTable
  } = externalConfig;
  const {
    type = 'Used'
  } = listing;
  const isNewVehicle = type ? type.toLowerCase() === 'new' : false;
  let supportedDealTypes = _supportedDealTypes;
  let dealerId = _dealerId;
  let digitalRetailingType = _digitalRetailingType;
  let disableTrade = _disableTrade;
  let disclaimerKey = _disclaimerKey;
  let enableCreditApp = _enableCreditApp;
  let enableCreditVerification = _enableCreditVerification;
  let enableDealReceipt = _enableDealReceipt;
  let enableExternalPaymentFetch = false;
  let enableNegotiation = _enableNegotiation;
  let enableOfferUpgrades = _enableOfferUpgrades;
  let enablePayoffQuote = _enablePayoffQuote;
  let enablePriceBreakdown = _enablePriceBreakdown;
  let enablePriceDetailsInOfferBreakdown = _enablePriceDetailsInOfferBreakdown;
  let enableTaxesAndFees = _enableTaxesAndFees || _includeTaxesAndFees;
  let enableWalletByDefault = false;
  const esntialDeepLink = _esntialDeepLink;
  let hideCTAs = false;
  let hideSendOfferCTA = _hideSendOfferCTA;
  let includeNewVehicleIncentives = _includeNewVehicleIncentives;
  let includeTaxesAndFees = _includeTaxesAndFees;
  let isSingleColumn = _isSingleColumn;
  let partnerId = _partnerId;
  let showLenderDisclaimer = _showLenderDisclaimer;
  let showLenderName = _showLenderName;
  let showLendingOptions = _showLendingOptions;
  let showNationalAvg = _showNationalAvg;
  let showMsrp = _showMsrp;
  let showRatesTable = _showRatesTable;
  let modifiedConfig = {};
  let isUDSStandAlone = false;
  switch (ecommerce // tenant level defaults
  ) {
    case 'CoxAuto':
      enableExternalPaymentFetch = true;
      if (_supportedDealTypes === undefined) {
        supportedDealTypes = ['finance', 'cash'];
      }
      if (_digitalRetailingType === undefined) {
        digitalRetailingType = 'default';
      }
      if (_disclaimerKey === undefined) {
        disclaimerKey = 'CoxAuto';
      }
      if (_enableCreditVerification === undefined) {
        enableCreditVerification = false;
      }
      if (_enableDealReceipt === undefined) {
        enableDealReceipt = false;
      }
      if (_enableNegotiation === undefined) {
        enableNegotiation = false;
      }
      if (_enableOfferUpgrades === undefined) {
        enableOfferUpgrades = !!(isNewVehicle && showMsrp && _enableOfferUpgrades); // Display dealer discount or dealer adjustment
      }
      if (_enablePayoffQuote === undefined) {
        enablePayoffQuote = false;
      }
      if (_enablePriceBreakdown === undefined) {
        enablePriceBreakdown = false; // Display entire price breakdown msrp, display dealer discount or dealer adjustment, manufacturer Offer
      }
      if (_enablePriceDetailsInOfferBreakdown === undefined) {
        enablePriceDetailsInOfferBreakdown = true;
      }
      if (_esntialDeepLink?.href && _esntialDeepLink?.label === undefined) {
        esntialDeepLink.label = 'Buy 100% Online';
      }
      if (_hideSendOfferCTA === undefined) {
        hideSendOfferCTA = true;
      }
      // include new vehicle incentives if vehicle is new vehicle
      if (_includeNewVehicleIncentives === undefined) {
        includeNewVehicleIncentives = isNewVehicle; // Display manufacturer Offer and also controls retail engine request params.
      }
      if (_includeTaxesAndFees === undefined) {
        includeTaxesAndFees = true; // Calculate taxes and fees on load
        enableTaxesAndFees = true; // Display taxes and fees button or See Details link
      }
      if (_isSingleColumn === undefined) {
        isSingleColumn = true; // Show single column layout
      }
      if (_showLenderDisclaimer === undefined) {
        showLenderDisclaimer = false;
      }
      // don't include lender name unless requested
      if (_showLenderName === undefined) {
        showLenderName = false;
      }
      if (_showLendingOptions === undefined) {
        showLendingOptions = false;
      }
      if (_showMsrp === undefined) {
        showMsrp = false; // Don't show msrp for esntial
      }
      if (_showNationalAvg === undefined) {
        showNationalAvg = false;
      }
      if (_showRatesTable === undefined) {
        showRatesTable = false;
      }
      break;
    case 'Accelerate':
      if (_digitalRetailingType === undefined) {
        digitalRetailingType = 'accelerate';
      }
      if (_disclaimerKey === undefined) {
        disclaimerKey = 'Accelerate';
      }
      if (_enableCreditApp === undefined) {
        enableCreditApp = true;
      }
      if (_enableCreditVerification === undefined) {
        enableCreditVerification = false;
      }
      if (_enableDealReceipt === undefined) {
        enableDealReceipt = true;
      }
      if (_enableNegotiation === undefined) {
        enableNegotiation = false;
      }
      if (_enableOfferUpgrades === undefined) {
        enableOfferUpgrades = true;
      }
      if (_enablePayoffQuote === undefined) {
        enablePayoffQuote = false;
      }
      if (_enablePriceBreakdown === undefined) {
        enablePriceBreakdown = false;
      }
      if (_enablePriceDetailsInOfferBreakdown === undefined) {
        enablePriceDetailsInOfferBreakdown = true;
      }
      if (_enableTaxesAndFees === undefined) {
        enableTaxesAndFees = true;
      }
      if (_includeNewVehicleIncentives === undefined) {
        includeNewVehicleIncentives = true;
      }
      if (_includeTaxesAndFees === undefined) {
        includeTaxesAndFees = false;
      }
      if (_isSingleColumn === undefined) {
        isSingleColumn = true;
      }
      if (_partnerId === undefined) {
        partnerId = 'MMD';
      }
      if (_showMsrp === undefined) {
        showMsrp = true;
      }
      if (_showLenderDisclaimer === undefined) {
        showLenderDisclaimer = false;
      }
      if (_showLenderName === undefined) {
        showLenderName = true;
      }
      if (_showNationalAvg === undefined) {
        showNationalAvg = false;
      }
      if (_showRatesTable === undefined) {
        showRatesTable = true;
      }
      break;
    case 'PSX':
      enableWalletByDefault = true;
      isUDSStandAlone = true;
      hideCTAs = true;
      if (_dealerId === undefined) {
        dealerId = 'psx20';
      }
      if (_digitalRetailingType === undefined) {
        digitalRetailingType = 'psx';
      }
      if (_disableTrade === undefined) {
        disableTrade = true;
      }
      if (_disclaimerKey === undefined) {
        disclaimerKey = 'PSX';
      }
      if (_enableCreditVerification === undefined) {
        enableCreditVerification = true;
      }
      if (_enableDealReceipt === undefined) {
        enableDealReceipt = false;
      }
      if (_enableNegotiation === undefined) {
        enableNegotiation = true;
      }
      if (_enablePayoffQuote === undefined) {
        enablePayoffQuote = false;
      }
      if (_enablePriceBreakdown === undefined) {
        enablePriceBreakdown = false;
      }
      if (_enableTaxesAndFees === undefined) {
        enableTaxesAndFees = false;
      }
      if (_includeNewVehicleIncentives === undefined) {
        includeNewVehicleIncentives = false;
      }
      if (_includeTaxesAndFees === undefined) {
        includeTaxesAndFees = false;
      }
      if (_isSingleColumn === undefined) {
        isSingleColumn = false;
      }
      if (_partnerId === undefined) {
        partnerId = 'AMK';
      }
      if (_showLenderDisclaimer === undefined) {
        showLenderDisclaimer = false;
      }
      if (_showLenderName === undefined) {
        showLenderName = true;
      }
      if (_showLendingOptions === undefined) {
        showLendingOptions = true;
      }
      if (_showMsrp === undefined) {
        showMsrp = false;
      }
      if (_showNationalAvg === undefined) {
        showNationalAvg = true;
      }
      if (_showRatesTable === undefined) {
        showRatesTable = true;
      }
      break;
    case 'BOA':
      if (_digitalRetailingType === undefined) {
        digitalRetailingType = 'accelerate';
      }
      if (_disclaimerKey === undefined) {
        disclaimerKey = 'BOA';
      }
      if (_isSingleColumn === undefined) {
        isSingleColumn = false;
      }
      if (_enableDealReceipt === undefined) {
        enableDealReceipt = true;
      }
      if (_showMsrp === undefined) {
        showMsrp = true;
      }
      if (_includeTaxesAndFees === undefined) {
        includeTaxesAndFees = false;
      }
      if (_enableNegotiation === undefined) {
        enableNegotiation = false;
      }
      if (_enableTaxesAndFees === undefined) {
        enableTaxesAndFees = true;
      }
      if (_enablePriceBreakdown === undefined) {
        enablePriceBreakdown = true;
      }
      if (_enablePayoffQuote === undefined) {
        enablePayoffQuote = false;
      }
      if (_includeNewVehicleIncentives === undefined) {
        includeNewVehicleIncentives = true;
      }
      if (_showLenderName === undefined) {
        showLenderName = true;
      }
      if (_showNationalAvg === undefined) {
        showNationalAvg = false;
      }
      if (_hideSendOfferCTA === undefined) {
        hideSendOfferCTA = true;
      }
      if (_partnerId === undefined) {
        partnerId = 'MMD';
      }
      break;
    default:
      showLenderDisclaimer = false;
      showRatesTable = false;
  }

  // rename configs for external product config properties UDS doesn't need to know about
  const disableIncentives = !includeNewVehicleIncentives;
  delete externalConfig.includeNewVehicleIncentives;
  modifiedConfig = {
    ...externalConfig,
    supportedDealTypes,
    listing,
    dealerId,
    digitalRetailingType,
    disableIncentives,
    disableTrade,
    disclaimerKey,
    enableCreditVerification,
    enableDealReceipt,
    enableExternalPaymentFetch,
    enableNegotiation,
    enableOfferUpgrades,
    enablePayoffQuote,
    enablePriceBreakdown,
    enablePriceDetailsInOfferBreakdown,
    enableTaxesAndFees,
    enableWalletByDefault,
    esntialDeepLink,
    hideCTAs,
    hideSendOfferCTA,
    includeTaxesAndFees,
    interestRates: fallbackInterestRates,
    isSingleColumn,
    partnerId,
    showLenderDisclaimer,
    showLenderName,
    showLendingOptions,
    showNationalAvg,
    showMsrp,
    showRatesTable,
    enableCreditApp,
    isUDSStandAlone
  };
  return modifiedConfig;
}
export { applyTenantCalculatorConfigs as default };
